export default __webpack_public_path__ + "static/media/b1.9f93cf62.jpg";